import { SVGProps, Ref, forwardRef } from 'react';

export const OneCGrayscaleSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M16.45 8.254c4.263 0 7.736 3.427 7.778 7.654h-2.065c-.043-3.095-2.589-5.602-5.714-5.602-3.151 0-5.716 2.55-5.716 5.682 0 2.284 1.364 4.252 3.322 5.153.112.052.547.21.654.241.562.163 1.274.27 1.894.31.183.014 1.009.021 1.197.021h14.197v2.044h-14.22a39 39 0 0 1-1.419-.03c-.759-.059-1.612-.193-2.305-.4a9 9 0 0 1-1.284-.534c-2.438-1.307-4.1-3.864-4.1-6.805 0-4.264 3.49-7.734 7.78-7.734"
                fill="#919191"
            />
            <path d="M4.278 23.75H2.28V13.328H-.003v-1.986h4.281z" fill="#919191" />
            <path d="M7.396 23.75H5.318V10.31H2.28V8.242h5.116z" fill="#919191" />
            <path
                d="M16.45 11.569c2.427 0 4.399 1.935 4.44 4.339h-1.982a2.455 2.455 0 0 0-2.459-2.367 2.454 2.454 0 0 0-2.46 2.447c0 .93.523 1.735 1.29 2.148.11.06.352.151.61.22.229.053.585.088.831.11.146.012.932.016 1.08.016h14.196v1.974H17.74v-.002c-.171-.002-.974-.008-1.138-.021a8.5 8.5 0 0 1-1.402-.212c-.12-.032-.538-.167-.76-.296a4.41 4.41 0 0 1-2.44-3.937c.001-2.442 1.993-4.419 4.448-4.42"
                fill="#919191"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28.442 9.055c.131 0 .445.044.445.39 0 .086-.02.226-.236.302.172.055.195.195.195.345.02.206 0 .248.052.303h-.247c-.056-.032-.056-.074-.056-.303 0-.118-.022-.249-.304-.249h-.197v.552h-.248v-1.34zm-.348.173v.422h.293c.208 0 .252-.119.252-.204 0-.163-.12-.218-.293-.218z"
                fill="#919191"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28.323 8.387c.773 0 1.37.592 1.37 1.338 0 .745-.597 1.36-1.37 1.36-.748 0-1.37-.615-1.37-1.36s.622-1.338 1.37-1.338m0 .216c-.617 0-1.151.496-1.152 1.122 0 .658.535 1.143 1.152 1.143.62 0 1.15-.485 1.15-1.143 0-.626-.53-1.122-1.15-1.122"
                fill="#919191"
            />
        </g>
    </svg>
));
OneCGrayscaleSize32Glyph.displayName = 'OneCGrayscaleSize32Glyph';
